"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _multiRequestEpic = _interopRequireDefault(require("settings-ui-sdk/multiRequestEpic"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _constants = require("settings-ui-sdk/DoiPages/constants");

var _actions = require("settings-ui-sdk/DoiPages/actions");

var _API = _interopRequireDefault(require("settings-ui-sdk/DoiPages/API"));

var _SaveActions = require("../actions/SaveActions");

var _saveChangesSelectors = require("../selectors/saveChangesSelectors");

var _UpdateDoiPages = _interopRequireWildcard(require("../stagedObjects/UpdateDoiPages"));

var computeDoiPageChangeActions = function computeDoiPageChangeActions(domainDoiPages, stagedDoiPages) {
  var removals = domainDoiPages.reduce(function (changes, page) {
    if (!stagedDoiPages.get(page.get(_constants.ID))) {
      return changes.concat((0, _actions.updateDoiPage)(page.set(_constants.ACTIVE, false).toJS()));
    }

    return changes;
  }, []);
  var updates = stagedDoiPages.reduce(function (changes, page) {
    if (!page.equals(domainDoiPages.get(page.get(_constants.ID)))) {
      return changes.concat((0, _actions.updateDoiPage)(page.toJS()));
    }

    return changes;
  }, []);
  return removals.concat(updates);
};

var updateDoiPageEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.update,
  initiatingActionType: _actions.DoiPagesActionTypes.UPDATE_DOI_PAGE,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.UpdateDoiPage
}));
var saveChangesEpic = (0, _multiRequestEpic.default)({
  requestEpics: [updateDoiPageEpic],
  mapStateToInitiatingActions: function mapStateToInitiatingActions(state) {
    return (0, _toConsumableArray2.default)(computeDoiPageChangeActions(_UpdateDoiPages.default.getDomainObject(state).get(_UpdateDoiPages.VALUES), _UpdateDoiPages.default.getStagedObject(state).get(_UpdateDoiPages.VALUES)));
  },
  metaInitiatingActionType: _SaveActions.SaveActionTypes.SAVE_CHANGES,
  metaRequestStatusSelector: _saveChangesSelectors.getSaveChangesRequestStatus,
  metaRequestActions: _SaveActions.SaveChanges
});
var _default = saveChangesEpic;
exports.default = _default;
module.exports = exports.default;